import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ElementRef,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Iplist } from './iplist';
import { Subscription, forkJoin, combineLatest, fromEvent } from 'rxjs';
import { nowDate } from './nowDate';
import { BraviaApiService } from '../service/bravia-api.service';
import { RoomNoService } from '../service/room-no.service';
import {
  getNowDateObject,
  getStreamNowDate
} from '../shared/tools/DateNowTime';
import { LanguageService } from '../service/language.service';
import { WeatherService } from '../service/weather/weather.service';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  animation,
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';
declare function require(x: string): any;

declare var Skycons: any;
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  animations: [
    trigger('ActiveMovie', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: '1' })),
      transition('inactive => active', [
        style({ display: 'block' }),
        animate('1000ms ease-in')
      ]),
      transition('active => inactive', [
        style({ display: 'block' }),
        animate('500ms ease-in') //閉じるときは開くときの半分の速度で
      ])
    ])
  ]
})
export class IndexComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('myVideo') myVideo: ElementRef<HTMLVideoElement>;

  isEng: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private braviaService: BraviaApiService,
    private roomNoService: RoomNoService,
    private languageService: LanguageService,
    private weatherService: WeatherService,
    private dbService: NgxIndexedDBService,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}
  ip = '';
  ssid = '';
  capacity: number;
  qr = '';
  password = '';
  room_no = '';
  sub: Subscription[] = [];
  now_date = getStreamNowDate();
  icons: Icon[] = [
    {
      uri: 'info',
      icon: 'assets/icons/jpn/stayinfo.svg',
      link: 'hoge',
      jpn: 'お知らせ',
      eng: 'Information',
      focused: true
    },

    {
      uri: 'stay-info',
      icon: 'assets/icons/jpn/service.svg',
      link: 'mirror',
      jpn: 'ゲストサービス',
      eng: 'Guest Service',
      focused: false
    },
    {
      uri: 'hotel-info',
      icon: 'assets/icons/jpn/hotelinfo.svg',
      link: 'wifi',
      jpn: '館内施設',
      eng: 'Facilities',
      focused: false
    },
    {
      uri: 'yakkan',
      icon: 'assets/icons/jpn/rule.svg',
      link: 'wifi',
      jpn: '宿泊約款/利用規約',
      eng: 'Regulation/Terms of service',
      focused: false
    },

    {
      uri: 'breakfast',
      icon: 'assets/icons/jpn/breakfast.svg',
      link: 'wifi',
      jpn: '朝食',
      eng: 'Breakfast',
      focused: false
    },
    {
      uri: 'streaming',
      icon: 'assets/icons/jpn/streaming.svg',
      link: 'wifi',
      jpn: '多言語放送',
      eng: '  Multilingual Broadcasting',
      focused: false
    },

    {
      uri:
        'com.sony.dtv.screnmirroring.com.screnmirroring.com.StartScreenMirroringHomeActivity',

      icon: 'assets/icons/jpn/mirroring.svg',
      link: 'wifi',
      jpn: 'ミラーリング',
      eng: ' Mirroring',
      focused: false
    },
    {
      uri: 'changeLang',
      icon: 'assets/icons/jpn/translate.svg',
      link: 'wifi',
      jpn: 'English',
      eng: '日本語',
      focused: false
    }
  ];

  now_date_obj: nowDate = getNowDateObject(
    new Date(),
    this.languageService.language
  );
  today_rainy: string; // 今日の降水確率
  tommorow_rainy: string; // 明日の降水確率
  today_temp: string;
  tommorow_temp: string;
  VideoUrl = 'https://kks03.xsrv.jp/okr/20240118.webm';
  fullVideoSrc: string | SafeHtml;
  Video = false;

  ngOnInit() {
    if (this.languageService.language === 'eng') {
      this.isEng = true;
    }

    /*    particlesJS.load('particles-js', '/assets/particles.json', null);*/
    this.changeIconForLang(this.languageService.language);

    this.weatherService.getWeather().subscribe(d => {
      this.today_rainy = Math.round(d.daily[0].pop * 10) * 10 + '%';
      this.tommorow_rainy = Math.round(d.daily[1].pop * 10) * 10 + '%';
      this.today_temp =
        Math.round(d.daily[0].temp.max) +
        '℃ / ' +
        Math.round(d.daily[0].temp.min) +
        '℃';
      this.tommorow_temp =
        Math.round(d.daily[1].temp.max) +
        '℃ / ' +
        Math.round(d.daily[1].temp.min) +
        '℃';
      const skycons = new Skycons({ color: '#fff' });
      const skycons_tomorrow = new Skycons({ color: '#fff' });

      skycons.add('today', Skycons[this.getSkycon(d.daily[0].weather[0].icon)]);
      skycons_tomorrow.add(
        'tomorrow',
        Skycons[this.getSkycon(d.daily[1].weather[0].icon)]
      );
      skycons.play();
      skycons_tomorrow.play();
    });

    // 現在時刻の表示
    this.sub.push(
      this.now_date.subscribe(d => {
        this.now_date_obj = getNowDateObject(d, this.languageService.language);
      })
    );
    // this.sub.push(
    combineLatest(this.route.paramMap, this.route.queryParams).subscribe(d => {
      const room_no = d[0].get('room');
      const ssid = d[1]['ssid'];
      if (!room_no) {
        // alert('部屋番号が設定されていません');
        // TODO エラーページに飛ばせばええんちゃう
      }
      const ip_list: Iplist[] = require('./iplist.json');
      const ip = ip_list.find(list => list.room_no === room_no);
      if (!ip) {
        // alert('存在しない部屋番号です');
        // TODO エラーページに飛ばせばええんちゃう
      }
      this.room_no = room_no; // 部屋番号
      this.ssid = ssid; // ssid

      this.capacity = 0;
      this.roomNoService.room_no = room_no; // 部屋番号をserviceに保存
      this.password = d[1]['key'];
      if (this.password) {
        localStorage.setItem('password', this.password);
        localStorage.setItem('ssid', this.ssid);
      } else {
        this.password = localStorage.getItem('password');
        this.ssid = localStorage.getItem('ssid');
      }
      this.qr = `WIFI:S:${this.ssid};T:WPA;P:${this.password};;`;
    });
    this.sub.push(
      // 指定言語によるアイコンの切り替え
      this.languageService.getObservable().subscribe(l => {
        this.changeIconForLang(l);
      })
    );

    console.log('fullvideo:' + this.fullVideoSrc);
    console.log('start movie');

    this.dbService.getByKey('movie', 1).subscribe(movie => {
      console.log('Movie is' + movie);
      if (movie === undefined) {
        // 初回DL
        this.http
          .get(this.VideoUrl, {
            responseType: 'blob'
          })
          .subscribe(movie => {
            console.log('success to download');
            console.log(movie);
            this.dbService
              .update('movie', { name: this.VideoUrl, data: movie, id: 1 })
              .subscribe(key => {
                console.log(key);
              });
            this.fullVideoSrc = this.sanitize(
              window.URL.createObjectURL(movie)
            );
          });
      } else {
        console.log(movie['name']);
        if (movie['name'] !== this.VideoUrl) {
          console.log('starting redonwload...');
          this.http
            .get(this.VideoUrl, {
              responseType: 'blob'
            })
            .subscribe(movie => {
              console.log('success to download');
              console.log(movie);
              this.dbService
                .update('movie', { name: this.VideoUrl, data: movie, id: 1 })
                .subscribe(key => {
                  console.log(key);
                });
              this.fullVideoSrc = this.sanitize(
                window.URL.createObjectURL(movie)
              );
            }); //const blob =  res.blob();
        } else {
          console.log('DB is Updated');
          this.fullVideoSrc = this.sanitize(
            window.URL.createObjectURL(movie['data'])
          );
        }
      }
    });

    const keyDown$ = fromEvent<KeyboardEvent>(document, 'keydown');

    this.sub.push(
      keyDown$.subscribe(d => {
        if (this.Video) {
          this.myVideo.nativeElement.pause();
          this.Video = false;
          if (d.key == 'Enter') {
            d.preventDefault();
          }
        }
      })
    );
  }

  changeIconForLang(l: string) {
    this.icons = this.icons.map(d => {
      const split_path = d.icon.split('/');
      split_path[2] = l;
      d.icon = split_path.join('/');
      return d;
    });
  }

  ngAfterViewInit() {
    if (sessionStorage.getItem('icon') === null) {
      (<any>document.querySelector('.icon_btn')).focus();
    } else {
      (<any>(
        document.querySelectorAll('.icon_btn')[
          Number(sessionStorage.getItem('icon'))
        ]
      )).focus();
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.forEach(d => d.unsubscribe());
    }
  }

  async aClick(i: number) {
    sessionStorage.setItem('icon', String(i));

    // なぜか他画面から戻った時にフォーカスが当たっている位置のクリックイベントが発火してしまう
    if (this.roomNoService.source !== '') {
      this.roomNoService.source = '';
      return;
    }
    if (/^com./.test(this.icons[i].uri)) {
      await this.braviaService.launchAppli(this.icons[i].uri);
    } else if (/^http./.test(this.icons[i].uri)) {
      window.open(this.icons[i].uri);
    } else if (/^sendHomeKey/.test(this.icons[i].uri)) {
      this.braviaService.sendHomeKey();
    } else if (/^changeLang/.test(this.icons[i].uri)) {
      this.changeLang();
    } else {
      this.router.navigate([this.icons[i].uri]);
    }
  }

  getSkycon(name: String): any {
    switch (name.slice(0, 2)) {
      case '01':
        return 'CLEAR_DAY';
      case '02':
        return 'PARTLY_CLOUDY_DAY';
      case '03':
        return 'CLOUDY';
      case '04':
        return 'CLOUDY';
      case '09':
        return 'RAIN';
      case '10':
        return 'RAIN';
      case '11':
        return 'RAIN';
      case '13':
        return 'SNOW';
      case '50':
        return 'FOG';
      default:
        return 'CLEAR_DAY';
    }
  }

  changeIcon(i: number) {
    //this.icons[i].focused = true;
  }
  blur() {
    this.icons.forEach(d => (d.focused = false));
  }
  changeLang() {
    if (this.languageService.language === 'jpn') {
      this.isEng = true;
      this.languageService.setEn();
    } else if (this.languageService.language === 'eng') {
      this.isEng = false;
      this.languageService.setJa();
    }
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  PlayVideo(): void {
    console.log('Play Video');
    this.Video = true;
    this.myVideo.nativeElement.play();
  }
  closeVideo(): void {
    console.log('close');
    this.Video = false;
    this.myVideo.nativeElement.pause();
  }
}
